import React from "react";
import { useNavigate } from "react-router-dom";
import "./EmailFailure.css"; // Optional CSS file for styling

const EmailFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="email-failure-container">
      <h1>Order Processed Successfully</h1>
      <p>
        Your payment was successful, and your order has been placed with our
        supplier. However, we encountered an internal error while sending your
        confirmation email.
      </p>
      <p>
        Please email{" "}
        <a href="mailto:info@bonobohope.org">info@bonobohope.org</a> with your
        order details to request your receipt. We apologize for the
        inconvenience!
      </p>
      <button className="return-button" onClick={() => navigate("/")}>
        Return to Home
      </button>
    </div>
  );
};

export default EmailFailure;
